import React, { Suspense, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { NavLink } from 'tools/Link'
import { LoadingTop as Loading } from 'tools/Loading'
import { cleanPath } from 'utils/string'

import { usePage } from 'reducer/global/hooks'

export function RedirectDefault({ path }) {
  const history = useHistory()

  useEffect(() => {
    history.replace(path)
  }, [path, history])

  return <></>
}

export function GenerateNav(props) {
  const { routes, navPath, navClass, tabClass } = props
  return (
    <div className={navClass ? navClass : 'flex items-center gh4 ml3'}>
      {Object.entries(routes)
        .filter(([, route]) => !route.hide)
        .map(([id, route]) => (
          <NavLink key={id} to={navPath(props, id)} className={tabClass}>
            {route.label}
          </NavLink>
        ))}
    </div>
  )
}

// children: [
//   TopLeftMenu,
//   TopLeftBar,
//   TopMiddleBar,
//   TopRightBar,
//   BottomBar = <></>
// ]
export function defaultNavPath({ root, routes, params: { targetId } }, tab) {
  return cleanPath(root, targetId ?? '_', tab)
}

export function SectionUpperNavRouter({
  routes,
  section,
  root = undefined,
  navPath = defaultNavPath,
  navClass = '',
  tabClass = '',
  itemId = 'targetId',
  viewKey = 'view',
  defroute = undefined,
  children = undefined
}) {
  const params = useParams()
  const innerNav = {
    Component: GenerateNav,
    args: { routes, navPath, root, navClass, tabClass, params }
  }

  usePage({ section, innerNav }, [params[itemId]])

  if (routes[params[viewKey]]) {
    const { Component } = routes[params[viewKey]]
    return (
      <Suspense fallback={<Loading />}>
        <Component />
      </Suspense>
    )
  }
  if (children) {
    return children
  }

  // or a summary
  if (defroute) {
    return <RedirectDefault path={navPath({ root, routes, params }, defroute)} />
  }
  const key0 = Object.keys(routes)[0]
  return <RedirectDefault path={navPath({ root, routes, params }, key0)} />
}

// export function SectionInlineNavRouter({
//   routes,
//   root,
//   tabKey,
//   navClass = 'mv4 max-view-page flex items-center justify-between bg-hilite',
//   tabClass = 'w-25 ttu f3 hover-hilight b pa2 pointer flex-center',
//   children = undefined
// }) {
//   const tab = useParams()[tabKey]
//
//   if (routes[tab]) {
//     const { Component } = routes[tab]
//     children = <Component />
//   }
//
//   if (children)
//     return (
//       <>
//         <GenerateNav
//           routes={routes}
//           root={root}
//           navClass={navClass}
//           tabClass={tabClass}
//         />
//         {children}
//       </>
//     )
//
//   // or a summary
//   const key0 = Object.keys(routes)[0]
//   return <RedirectDefault path={`${root}/${key0}`} />
// }

export default SectionUpperNavRouter
